// Ensure have websiteUserId on cart attributes
const allCookies = Object.entries(Cookies.get());
const cookieRegex = /CognitoIdentityServiceProvider\..+?\.LastAuthUser/;
const websiteUserIdAttribute = "websiteUserId";
const userIdCookie = allCookies.find(([key]) => key.match(cookieRegex));

if (userIdCookie) {
    fetch(window.Shopify.routes.root + 'cart.js')
        .then(r => r.json())
        .then(cart => {
            const userId = userIdCookie[1];
            if (cart.attributes && cart.attributes[websiteUserIdAttribute] === userId) {
                return;
            }
            
            const formData = new FormData();
            formData.append(`attributes[${websiteUserIdAttribute}]`, userId);
            fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                body: formData
            })
        });
}